import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextoService } from '@core/services/contexto.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-secondary-navbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './segundo-navbar.component.html',
  styleUrls: ['./segundo-navbar.component.scss']
})
export class SegundoNavbarComponent implements OnInit, OnDestroy {
  public readonly mensajePendiente = 'Pendiente de asignar';
  public nombreOrganizacion = '';
  public nombreRol = '';

  private readonly contextoService = inject(ContextoService);
  private readonly destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.cargarContexto();
    
    this.contextoService.contextoActual$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.cargarContexto());
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private cargarContexto(): void {
    const contexto = this.contextoService.obtenerContextoActivo();
    if (contexto) {
      this.nombreOrganizacion = contexto.razonSocial || '';
      this.nombreRol = contexto.roles?.length > 0 ? contexto.roles[0] : '';
    }
  }
}